module.exports = __webpack_public_path__ + "img/rent-normal.6350e692.jpeg";